import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import styles from "./styles/AppContainerSubHeader.module.css";
import moment from "moment";
const AppContainerSubHeader = () => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  useEffect(() => {
    let interval = setInterval(() => {
      let _time = moment().format("HH:mm");
      setTime(_time);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let _date = moment().format("MM/DD/YYYY");
    setDate(_date);
  }, []);

  return (
    <Row className={styles.background} justify="space-between">
      <Col>Date: {date}</Col>
      <Col>Time: {time}</Col>
    </Row>
  );
};

export default AppContainerSubHeader;
